import React, { Component } from 'react';
import Menu from "../components/Menu";
import Axios from "axios";
import ApiUrl from "../AppUrl/ApiUrl";
import { toast } from "react-toastify";
import Loading from "../components/Loading";
import AppUrl from "../AppUrl/ApiUrl";

class EditAirdropCurrency extends Component {
    constructor({ match }) {
        super();
        this.state = {
            coin_name: "", coin_symbol: "", coin_code: "", coin_type: "Token", coin_platform: "Binance", smart_contract: "", coin_decimal: "",
            withdrew_fee: "0.005", fee_currency_name: "ETH", can_deposit: "1", can_withdraw: "1", explorer: "",
            address_default: "", price: "0", day_change: "0", status: "1", swap: "",
            logo_img: null, token: "", id: match.params.id,
            loading: true, coin: [], min_withdrew: ""
        }
    }

    async componentDidMount() {
        var token = localStorage.getItem("admintoken")
        this.setState({ token: token })
        Axios.get(AppUrl.baseurl + "all-coin")
            .then(res => {
                this.setState({ coin: res.data })
            })
            .catch(err => {
                console.log(err)
            })

        await Axios.get(ApiUrl.baseurl + "coin/" + this.state.id)
            .then(res => {
                if (!res.data.error && res.data[0]) {
                    const data = res.data[0];
                    this.setState({
                        coin_name: data['coin_name'] || "",
                        coin_symbol: data['coin_symbol'] || "",
                        coin_code: data['code'] || "",
                        coin_type: data['coin_type'] || "Token",
                        coin_platform: data['platform'] || "Binance",
                        smart_contract: data['contract'] || "",
                        coin_decimal: data['coin_decimal'] || "",
                        withdrew_fee: data['fee'] || "0",
                        fee_currency_name: data['fee_coin'] || "",
                        can_deposit: String(data['deposit'] ?? "1"),
                        price: data["price"] || "0",
                        can_withdraw: String(data["withdrew"] ?? "1"),
                        explorer: data['explorer'] || "",
                        min_withdrew: data["min_withdrew"] || "",
                        address_default: data['fund_address'] || "",
                        loading: false
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
    }

    logo_img = (e) => {
        if (e.target.files && e.target.files[0]) {
            this.setState({ logo_img: e.target.files[0] })
        }
    }
    min_withdrew = (e) => this.setState({ min_withdrew: e.target.value })
    explorer = (e) => this.setState({ explorer: e.target.value })
    can_withdraw = (e) => this.setState({ can_withdraw: e.target.value })
    can_deposit = (e) => this.setState({ can_deposit: e.target.value })
    withdrew_fee = (e) => this.setState({ withdrew_fee: e.target.value })
    coin_code = (e) => this.setState({ coin_code: e.target.value })
    coin_decimal = (e) => this.setState({ coin_decimal: e.target.value })
    smart_contract = (e) => this.setState({ smart_contract: e.target.value })
    coin_platform = (e) => this.setState({ coin_platform: e.target.value })
    coin_type = (e) => this.setState({ coin_type: e.target.value })
    coin_name = (e) => this.setState({ coin_name: e.target.value })
    coin_symbol = (e) => this.setState({ coin_symbol: e.target.value })
    price = (e) => this.setState({ price: e.target.value })
    address_default = (e) => this.setState({ address_default: e.target.value }) // আনকমেন্ট করা হয়েছে

    onSubmitForm = (event) => {
        event.preventDefault()
        var val = this.state
        var formData = new FormData()

        formData.append("id", val.id)
        formData.append("token", val.token)
        formData.append("coin_name", val.coin_name)
        formData.append("coin_symbol", val.coin_symbol)
        formData.append("code", val.coin_code)
        formData.append("coin_type", val.coin_type)
        formData.append("platform", val.coin_platform)
        formData.append("contract", val.smart_contract)
        formData.append("coin_decimal", val.coin_decimal)
        formData.append("price", val.price)
        formData.append("fee", val.withdrew_fee)
        formData.append("deposit", val.can_deposit)
        formData.append("withdrew", val.can_withdraw)
        formData.append("explorer", val.explorer || "")
        formData.append("fund_address", val.address_default || "")
        formData.append("min_withdrew", val.min_withdrew || "")

        // কেবল নতুন ফাইল সিলেক্ট করলেই 'logo' পাঠানো হবে, নতুবা না (যাতে 422 এরর না আসে)
        if (val.logo_img instanceof File) {
            formData.append("logo", val.logo_img)
        }

        Axios.post(ApiUrl.baseurl + "update-coin", formData)
            .then(res => {
                if (res.data.success) {
                    toast.success(res.data.success, { position: "top-right", autoClose: 3000 });
                    setTimeout(() => this.props.history.push(`/currency/airdrop`), 1000)
                } else {
                    toast.error(res.data.error || "Update failed", { position: "top-right", autoClose: 3000 });
                }
            })
            .catch(error => {
                console.log(error)
                toast.error("Something went wrong!", { position: "top-right" });
            })
    }

    render() {
        return (
            <Menu title="Edit update Currency And Coin">
                <h3 className="bg-white title-head"> Edit Airdrop Currency </h3>
                <div className="container-fluid currency-add">
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.loading ? <Loading /> :
                                <form onSubmit={this.onSubmitForm}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Coin Name</label>
                                            <input type="text" required value={this.state.coin_name} onChange={this.coin_name} className="form-control shadow-none" placeholder="Bitcoin" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Coin Symbol</label>
                                            <input type="text" value={this.state.coin_symbol} onChange={this.coin_symbol} className="form-control shadow-none" required placeholder="BTC" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Coin Code</label>
                                            <input type="text" value={this.state.coin_code} onChange={this.coin_code} className="form-control shadow-none" required placeholder="BTC" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Coin Type</label>
                                            <select required value={this.state.coin_type} onChange={this.coin_type} className="form-control shadow-none">
                                                <option value="">Select Type</option>
                                                <option value="Coin">Coin</option>
                                                <option value="Token">Token</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label>Coin Platform</label>
                                            <select required value={this.state.coin_platform} onChange={this.coin_platform} className="form-control shadow-none">
                                                <option value="">Select Platform</option>
                                                <option value="Ethereum">Ethereum</option>
                                                <option value="Binance">Binance</option>
                                                <option value="Brilliance">Brilliance</option>
                                                <option value="Polygon">Polygon</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label>Coin Smart Contract</label>
                                            <input type="text" value={this.state.smart_contract} onChange={this.smart_contract} className="form-control shadow-none" placeholder="Smart Contract" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Coin Decimal</label>
                                            <input type="number" value={this.state.coin_decimal} onChange={this.coin_decimal} className="form-control shadow-none" placeholder="8" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Coin Withdrew Fee</label>
                                            <input type="text" value={this.state.withdrew_fee} onChange={this.withdrew_fee} className="form-control shadow-none" placeholder="0.001" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Can Deposit</label>
                                            <select required value={this.state.can_deposit} onChange={this.can_deposit} className="form-control shadow-none">
                                                <option value="1">Yes</option>
                                                <option value="0">No</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label>Can Withdrew</label>
                                            <select required value={this.state.can_withdraw} onChange={this.can_withdraw} className="form-control shadow-none">
                                                <option value="1">Yes</option>
                                                <option value="0">No</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <label>Explorer</label>
                                            <input type="text" value={this.state.explorer} onChange={this.explorer} className="form-control shadow-none" placeholder="Explorer link" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Coin Logo (Choose only to change)</label>
                                            <input type="file" onChange={this.logo_img} className="form-control shadow-none" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Fund Transfer Address</label>
                                            <input type="text" value={this.state.address_default} onChange={this.address_default} className="form-control shadow-none" placeholder="Address" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Coin Price</label>
                                            <input type="text" value={this.state.price} onChange={this.price} className="form-control shadow-none" placeholder="Price" />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Min Withdrew</label>
                                            <input type="text" value={this.state.min_withdrew} onChange={this.min_withdrew} className="form-control shadow-none" placeholder="0.1" />
                                        </div>
                                        <div className="col-md-12 mt-4 mb-5">
                                            <button type="submit" className="btn btn-primary shadow-none">Update</button>
                                        </div>
                                    </div>
                                </form>
                            }
                        </div>
                    </div>
                </div>
            </Menu>
        );
    }
}

export default EditAirdropCurrency;